export default __webpack_public_path__ + "static/media/SleepingFox.d017c875.png";